import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MultiProgressBarComponent } from './multi-progress-bar.component';


@NgModule({
    imports: [
        CommonModule,
        // BrowserAnimationsModule
    ],
    exports: [MultiProgressBarComponent],
    declarations: [MultiProgressBarComponent],
    providers: [],
})
export class MultiProgressBarModule { }
